import { IJsonQuery } from '@cian/api-models/common/json_query';
import { reverse } from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TThunkDispatch } from '../../types/redux';
import { term } from '../../../packages/JsonQuery/constructors';
import { closeSaveSearchModal } from '../../actions/saveSearch';
import { selectIsOpen } from '../../selectors/saveSearch';
import { selectJsonQuery } from '../../selectors/results';
import { selectMapBounds } from '../../selectors/mapBounds';
import { selectUser } from '../../selectors/user/user';
import { SaveSearchModal } from '../../components/SaveSearchModal';
import { useApplicationContext } from '../ApplicationContext';

export const SaveSearchModalContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const user = useSelector(selectUser);
  const {
    logger,
    httpApi,
    custom: { subdomain },
  } = useApplicationContext();
  const jsonQuery = useSelector(selectJsonQuery);
  const mapBounds = useSelector(selectMapBounds);
  const isOpen = useSelector(selectIsOpen);

  const handleClose = React.useCallback(() => {
    dispatch(closeSaveSearchModal());
  }, [dispatch]);

  const jsonQueryWithBounds: IJsonQuery = {
    ...jsonQuery,
    bbox: term(mapBounds.bounds?.map(bounds => reverse(bounds)) as [YMaps.TCoord, YMaps.TCoord]),
  };

  return (
    <SaveSearchModal
      userEmail={(user.isAuthenticated && user.email) || null}
      hideLicense={user.isAuthenticated}
      subdomain={subdomain}
      jsonQuery={jsonQueryWithBounds}
      httpApi={httpApi}
      logger={logger}
      isOpen={isOpen}
      onClose={handleClose}
    />
  );
};
